<template>
    <div class="travel-and-insurance" v-if="edit" ref="scrollTarget">
        <h1>{{ $t("Travel & Insurance") }}</h1>
        <div id="insurance">
            <p>{{ $t("If you already know your insurance details, please enter them below. If you don’t yet, please phone or email us to provide them at a later date.") }}</p>
            <div id="insurance_form2">
            
                <div class="div2020-3">
                    <label for="insurance_provider">{{ $t("Insurance Provider") }}
                        <RequiredMark :isValid="is_insurance_provider_valid"/>
                        </label> 
                    <input
                      class="inputbtn btndefault btnblock"
                      type="text"
                      id="insurance_provider"
                      v-model="insurance_provider"
                      >
                </div>
                <div class="div2020-3">
                    <label for="policy_number">{{ $t("Policy Number") }}
                        <RequiredMark :isValid="is_policy_number_valid"/>
                        </label> 
                    <input
                      class="inputbtn btndefault btnblock"
                      type="text"
                      id="policy_number"
                      v-model="policy_number"
                      >
                </div>
                <div class="div2020-3">            
                    <label for="emergency_phone">{{ $t("Emergency assistance 24-hr helpline") }}
                        <RequiredMark :isValid="is_emergency_phone_valid"/>
                        </label> 
                    <input
                      class="inputbtn btndefault btnblock"
                      type="text"
                      id="emergency_phone"
                      v-model="emergency_phone"
                      >
                </div>
            </div>
        </div>
        <div id="ferry_information" v-if="this.getCurrency.currency=='GBP'">
            <h1>{{ $t("Ferry Information") }}</h1>
            <p>{{ $t("Please choose one of the following options") }}: <RequiredMark :isValid="ferry_option!==null"/></p>
            <div class="button_selection" id="ferry_option_selection" >
                <button
                  :class="{ 'ferry_type_active': ferry_option=='ferry', 'ferry_type_selected': ferry_option!==null }"
                  @click.prevent="ferryOptionChosen">
                    {{ $t("I’d like to book") }} <br>{{ $t("a ferry or Tunnel crossing.") }}
                </button>
                <button
                  :class="{ 'ferry_type_active': ferry_option=='notsure', 'ferry_type_selected': ferry_option!==null }"
                  @click.prevent="ownOptionChosen">
                    {{ $t("I’m not sure about ferries") }} <br>{{ $t("please don’t book anything yet") }}  
                </button>
                <button
                  :class="{ 'ferry_type_active': ferry_option=='own', 'ferry_type_selected': ferry_option!==null }"
                  @click.prevent="notsureOptionChosen">
                    {{ $t("I will arrange my own travel, thanks") }}  
                </button>
            </div>
            <div id="additional_items" v-if="this.ferry_option=='ferry'" >
                <h3>{{ $t("Please tell us about any items in addition to your basic vehicle") }}</h3>
                <div>
                    <div class="radio_div">
                        <input type="checkbox" id="Roof_box" value="Roof box" v-model="checkedAdditionalItems">
                        <label for="Roof_box">{{ $t("Roof box") }}</label>
                    </div>
                    <div class="radio_div">
                        <input type="checkbox" id="Bikes_on_the_roof" value="Bikes on the roof" v-model="checkedAdditionalItems">
                        <label for="Bikes_on_the_roof">{{ $t("Bikes on the roof") }}</label>
                    </div>
                    <div class="radio_div">
                        <input type="checkbox" id="Bikes_on_rear_carrier" value="Bikes on rear carrier" v-model="checkedAdditionalItems">
                        <label for="Bikes_on_rear_carrier">{{ $t("Bikes on rear carrier") }}</label>
                    </div>
                    <div class="radio_div">
                        <input type="checkbox" id="Trailer" value="Trailer" v-model="checkedAdditionalItems">
                        <label for="Trailer">{{ $t("Trailer") }}. 
                            <span class="newline"></span>
                            <span class="indent"></span>
                            {{ $t("Length") }} 
                            <input
                              v-model="trailer_length"
                              @keyup="trailerDetailsChanged"
                              @change="trailerDetailsChanged"
                              class="inline_input"
                              type="number">{{ $t("cm") }}  x {{ $t("Height") }} 
                            <input
                              v-model="trailer_height"
                              @keyup="trailerDetailsChanged"
                              @change="trailerDetailsChanged"
                              class="inline_input"
                              type="number">{{ $t("cm") }}</label>
                    </div>
                    <div class="radio_div">
                        <input type="checkbox" id="Caravan" value="Caravan" v-model="checkedAdditionalItems">
                        <label for="Caravan">{{ $t("Caravan") }}. 
                            <span class="newline"></span>
                            <span class="indent"></span>
                            {{ $t("Length") }} 
                            <input
                              v-model="caravan_length"
                              @keyup="caravanDetailsChanged"
                              @change="caravanDetailsChanged"
                              class="inline_input"
                              type="number">{{ $t("cm") }}  x {{ $t("Height") }} 
                            <input
                              v-model="caravan_height"
                              @keyup="caravanDetailsChanged"
                              @change="caravanDetailsChanged"
                              class="inline_input"
                              type="number">{{ $t("cm") }} </label>
                    </div>
                    <div class="radio_div">
                        <input type="checkbox" id="Other_information" value="Other information" v-model="checkedAdditionalItems">
                        <label for="Other_information">{{ $t("Other information") }} 
                            <span class="newline"></span>
                            <span class="indent"></span>
                            <input
                              v-model="other_information"
                              @keyup="otherInfoChanged"
                              class="inline_input size30"
                              type="text"
                              maxlength="30">
                        </label>
                    </div>
                </div>
            </div>
            <div id="ferry_operator_selection" v-if="this.ferry_option=='ferry'" >
                <h3>{{ $t("Please select one of the five operators below and tell us your dates, times and other details.") }} 
                    <RequiredMark :isValid="ferry_operator!==null"/>
                </h3>
                <div class="button_selection" id="ferry_operator_selection">
                    <button
                      :class="{ 
                            'ferry_type_active': ferry_operator=='P&O Dover – Calais', 
                            'ferry_type_selected': ferry_operator!==null }"
                      @click.prevent="ferryOperatorChosen('P&O Dover – Calais')"
                      >P&O Dover – Calais. {{ $t("Included in your holiday price.") }}</button>
                    <button
                        v-if="false"
                      :class="{ 
                            'ferry_type_active': ferry_operator=='P&O Hull – Zeebrugge', 
                            'ferry_type_selected': ferry_operator!==null }"
                      @click.prevent="ferryOperatorChosen('P&O Hull – Zeebrugge')"
                      >P&O Hull – Zeebrugge</button>
                    <button
                      :class="{ 
                            'ferry_type_active': ferry_operator=='Brittany Ferries', 
                            'ferry_type_selected': ferry_operator!==null }"
                      @click.prevent="ferryOperatorChosen('Brittany Ferries')"
                      >Brittany Ferries from Portsmouth, Poole or Plymouth</button>
                    <button
                      :class="{ 
                            'ferry_type_active': ferry_operator=='DFDS', 
                            'ferry_type_selected': ferry_operator!==null }"
                      @click.prevent="ferryOperatorChosen('DFDS')"
                      >DFDS Newhaven – Dieppe</button>
                    <button
                      :class="{ 
                            'ferry_type_active': ferry_operator=='Eurotunnel', 
                            'ferry_type_selected': ferry_operator!==null }"
                      @click.prevent="ferryOperatorChosen('Eurotunnel')"
                      >Eurotunnel Folkestone - Calais</button>
                </div>
                <div id="ferry_companies">
                    <div
                        v-if="ferry_operator=='P&O Dover – Calais'"
                      class="ferry_company">
                        <h4>P&O (Dover – Calais)</h4>

                        <p>{{ $t("There are crossings on this route approximately once an hour. Please indicate your dates and preferred travel times:") }}</p>

                        <div>
                            <label for="outbount_return_1">{{ $t("Outbound") }}
                                <RequiredMark :isValid="isOutboundValid"/>
                                </label>  
                            <input
                              type="text"
                              id="outbount_return_1"
                              v-model="outbound_text">
                        </div>
                        <div>
                            <label for="outbount_return_2">{{ $t("Return") }}
                                <RequiredMark :isValid="isReturnValid"/>
                                </label>  
                            <input
                              type="text"
                              id="outbount_return_2"
                              v-model="return_text">
                    </div>
                        </div>
                    <div
                        v-if="ferry_operator=='P&O Hull – Zeebrugge'"
                      class="ferry_company">
                        <h4>P&O (Hull – Zeebrugge)</h4>

                        <p>{{ $t("There is one sailing each day, always overnight, so cabins must be booked. ") }}</p>
                        <p>{{ $t("Dinner and breakfast packages are cheaper if booked in advance.") }}</p>
                        <p>{{ $t("Please indicate your preferences for dates, cabins and meals:") }}</p>

                        <div>
                            <label for="outbount_return_3">{{ $t("Outbound") }}
                                <RequiredMark :isValid="isOutboundValid"/>
                                </label>  
                            <input
                              type="text"
                              id="outbount_return_3"
                              v-model="outbound_text">
                        <div>
                            </div>
                            <label for="outbount_return_4">{{ $t("Return") }}
                                <RequiredMark :isValid="isReturnValid"/>
                                </label>  
                            <input
                              type="text"
                              id="outbount_return_4"
                              v-model="return_text">
                        </div>
                    </div>
                    <div
                        v-if="ferry_operator=='Brittany Ferries'"
                      class="ferry_company">
                        <h4>Brittany Ferries ({{ $t("all routes") }})</h4>

                        <p>{{ $t("Please indicate your preferred route, date and time for travel in each direction (you can choose a different route each way), along with any cabin or seat requests:") }}</p>

                        <div>
                            <label for="outbount_return_5">{{ $t("Outbound") }}
                                <RequiredMark :isValid="isOutboundValid"/>
                                </label>  
                            <input
                              type="text"
                              id="outbount_return_5"
                              v-model="outbound_text">
                        </div>
                        <div>
                            <label for="outbount_return_6">{{ $t("Return") }}
                                <RequiredMark :isValid="isReturnValid"/>
                                </label>  
                            <input
                              type="text"
                              id="outbount_return_6"
                              v-model="return_text">
                    </div>
                        </div>
                    <div
                        v-if="ferry_operator=='DFDS'"
                      class="ferry_company">
                        <h4>DFDS (Newhaven – Dieppe)</h4>

                        <p>{{ $t("There are three crossings each day. Please indicate your preferred dates and timings, along with any cabin requests:") }}</p>

                        <div>
                            <label for="outbount_return_7">{{ $t("Outbound") }}
                                <RequiredMark :isValid="isOutboundValid"/>
                                </label>  
                            <input
                              type="text"
                              id="outbount_return_7"
                              v-model="outbound_text">
                        </div>
                        <div>
                            <label for="outbount_return_8">{{ $t("Return") }}
                                <RequiredMark :isValid="isReturnValid"/>
                                </label>  
                            <input
                              type="text"
                              id="outbount_return_8"
                              v-model="return_text">
                    </div>
                        </div>
                    <div
                        v-if="ferry_operator=='Eurotunnel'"
                      class="ferry_company">
                        <h4>Eurotunnel</h4>

                        <p>{{ $t("There are crossings on this route 2-3 times an hour. Please indicate the dates and ideal timings that you would like to travel out and back:") }}</p>

                        <div>
                            <label for="outbount_return_9">{{ $t("Outbound") }}
                                <RequiredMark :isValid="isOutboundValid"/>
                                </label>  
                            <input
                              type="text"
                              id="outbount_return_9"
                              v-model="outbound_text">
                        </div>
                        <div>
                            <label for="outbount_return_10">{{ $t("Return") }}
                                <RequiredMark :isValid="isReturnValid"/>
                                </label>  
                            <input
                              type="text"
                              id="outbount_return_10"
                              v-model="return_text">
                        </div>
                    </div>
                    <hr>
                </div>
            </div>

        </div>
        <div  class="continue_button">
            <button class="button blue" v-if="false">Phone me</button>
            <button
            href="#"
            class="button blue"
            :disabled="hasInvalidFields"
            @click.prevent="continueToTravelSUmmary">{{ $t("Continue") }} &gt;&gt;</button> 

        </div>    

    </div>
    <div id="travel_summary" v-else>
        <h3 class="customer-title">{{ $t("Insurance") }}</h3>
        <p>{{ $t("Insurance Provider") }}: <strong>{{insurance_provider}}</strong></p>
        <p>{{ $t("Policy Number") }}: <strong>{{policy_number}}</strong></p>
        <p>{{ $t("Emergency assistance 24-hr helpline") }}: <strong>{{emergency_phone}}</strong></p>
        <h3 class="customer-title">{{ $t("Travel details") }}</h3>
        <ul v-for="(line, index) in getBookingDetails.additional_lines" :key="index">
            <li>{{line}}</li>
        </ul>
        <div  class="continue_button">
            <button class="button blue" v-if="false">Phone me</button> 
            <button
            href="#"
            class="button blue"
            :disabled="hasInvalidFields"            
            @click.prevent="edit=true">{{ $t("Change Details") }}</button> &nbsp;
            <button
            href="#"
            class="button blue"
            :disabled="hasInvalidFields"
            @click.prevent="continueToDiscounts">{{ $t("Continue") }} &gt;&gt;</button> 
        </div>  
    </div>         
</template>

<script>
    import { mapGetters } from 'vuex';
    export default {
        data() {
            return {
                edit: true, // edit or summary
                insurance_provider: '',
                policy_number: '',
                emergency_phone: '',

                checkedAdditionalItems: [],
                trailer_length: null,
                trailer_height : null,
                caravan_length: null,
                caravan_height : null,
                other_information : null,
                
                ferry_option : null, // 'ferry','notsure','own'

                ferry_items : [],

                ferry_operator : null,
                outbound_text : '',
                return_text : '',
            }
        },
        computed: {
            ...mapGetters([
                'getInsurance',
                'getBookingDetails',
                'getFerries',
                'getCurrency',
            ]),        

            is_insurance_provider_valid(){
                return this.insurance_provider!=''
            },
            is_policy_number_valid(){
                return this.policy_number!=''
            },
            is_emergency_phone_valid(){
                return this.emergency_phone!=''
            },  
            isOutboundValid(){
                return this.outbound_text!='';
            },
            isReturnValid(){
                return this.return_text!='';
            },      
            hasInvalidFields() {
                let hasInsuranceDetails = this.insurance_provider!='' && this.policy_number!='' && this.emergency_phone!='';
                let gbpWithoutSelection =this.getCurrency.currency=='GBP'&&this.ferry_option==null;
                let ferrySelectedWithoutOtherFields=this.ferry_option=='ferry'&&(this.outbound_text==''||this.return_text=='');
                console.log('--------------');
                console.log('hasInsuranceDetails---',hasInsuranceDetails);
                console.log('GBP without selection',gbpWithoutSelection);
                console.log('ferry selected without other fields',ferrySelectedWithoutOtherFields);
                // {{getCurrency.currency=='GBP'
                return !hasInsuranceDetails||gbpWithoutSelection||ferrySelectedWithoutOtherFields;
            }
        },
        methods: {
            ferryOptionChosen() {
                this.ferry_option='ferry';
                this.saveFerries();
            },
            ferryOperatorChosen (operator) {
                this.ferry_operator=operator;
                console.log('operator',operator);
            },         
            ownOptionChosen() {
                this.ferry_option='notsure';
                this.saveFerries();
            },
            notsureOptionChosen() {
                this.ferry_option='own';
                this.saveFerries();
            },
            continueToTravelSUmmary() {
                this.saveInsurance();
                this.saveFerries();
                 if (this.ferry_option=='ferry') {
                    this.edit=false;
                    const target = this.$refs.scrollTarget;
                    const targetPosition = target.offsetTop;
                    window.scrollTo({
                        top: targetPosition,
                        behavior: "smooth"
                    });                    
                 } else {
                    this.$store.commit('CHANGE_PROGRESS_STEP',4);
                    this.$router.push({name: "DiscountsAndOffers",hash:'#appTop'});
                 }
                console.log('continueToTravelSUmmary');
            },
            continueToDiscounts() {
                console.log('continueToDiscounts');
                // this.saveInsurance();
                this.saveInsurance();
                this.saveFerries();
                this.$store.commit('CHANGE_PROGRESS_STEP',4);
                this.$router.push({name: "DiscountsAndOffers",hash:'#appTop'});

                // this.edit=false;
            },
            saveInsurance() {
                this.$store.commit('UPDATE_INSURANCE',
                    {
                        'insurance_provider':this.insurance_provider,
                        'policy_number':this.policy_number,
                        'emergency_phone':this.emergency_phone
                    }
                );
            },
            loadInsurance() {
                this.insurance_provider = this.getInsurance.insurance_provider;
                this.policy_number = this.getInsurance.policy_number;
                this.emergency_phone = this.getInsurance.emergency_phone;
            },

            loadFerries() {
                this.checkedAdditionalItems = this.getFerries.ferry_items;
                this.trailer_length = this.getFerries.trailer_length;
                this.trailer_height = this.getFerries.trailer_height;
                this.caravan_length = this.getFerries.caravan_length;
                this.caravan_height = this.getFerries.caravan_height;
                this.other_information = this.getFerries.other_information;
                this.ferry_option = this.getFerries.ferry_option;
                this.ferry_operator = this.getFerries.ferry_operator;
                this.outbound_text = this.getFerries.outbound_text;
                this.return_text = this.getFerries.return_text;
            },
            saveFerries() {
                console.log('saveFerries');

                this.$store.commit('UPDATE_FERRIES',
                    {
                        'ferry_items':this.checkedAdditionalItems,

                        'trailer_length':this.trailer_length,
                        'trailer_height':this.trailer_height,
                        'caravan_length':this.caravan_length,
                        'caravan_height':this.caravan_height,
                        'other_information':this.other_information,

                        'ferry_option':this.ferry_option,
                        'ferry_operator':this.ferry_operator,
                        'outbound_text':this.outbound_text,
                        'return_text':this.return_text
                    }
                );
            },
            //additional ferry items functions
            otherInfoChanged () {
                var index = this.checkedAdditionalItems.indexOf('Other information');
                console.log('otherInfoChanged',index);
                if (this.other_information) {
                    if (index ==-1) {
                        this.checkedAdditionalItems.push('Other information');
                    }
                } else {
                    if (index !== -1) {
                        this.checkedAdditionalItems.splice(index, 1);
                    }
                }
            },
            trailerDetailsChanged () {
                var index = this.checkedAdditionalItems.indexOf('Trailer');
                console.log('trailerDetailsChanged',index);
                if (this.trailer_length>0&&this.trailer_height>0) {
                    if (index ==-1) {
                        this.checkedAdditionalItems.push('Trailer');
                    }
                } else {
                    if (index !== -1) {
                        this.checkedAdditionalItems.splice(index, 1);
                    }
                }
            },
            caravanDetailsChanged () {
                var index = this.checkedAdditionalItems.indexOf('Caravan');
                console.log('caravanDetailsChanged',index);
                if (this.caravan_length>0&&this.caravan_height>0) {
                    if (index ==-1) {
                        this.checkedAdditionalItems.push('Caravan');
                    }
                } else {
                    if (index !== -1) {
                        this.checkedAdditionalItems.splice(index, 1);
                    }
                }
            },
        },
        created() {
            this.loadInsurance();
            this.loadFerries();
            // this.insurance_provider=this.getInsurance.insurance_provider;
            // this.policy_number=this.getInsurance.policy_number;
            // this.emergency_phone=this.getInsurance.emergency_phone;

            // this.checkedAdditionalItems=this.getFerries.ferry_items;
            // this.trailer_length=this.getFerries.trailer_length;
            // this.trailer_height=this.getFerries.trailer_height;
            // this.caravan_length=this.getFerries.caravan_length;
            // this.caravan_height=this.getFerries.caravan_height;
            // this.other_information=this.getFerries.other_information;
            
        },
        mounted() {
            if (this.getCurrency.PriceTypeID==9) {
                this.continueToTravelSUmmary();
            }
        },
        unmounted() {
            this.saveInsurance();
            this.saveFerries();
        }
    }
</script>

<style scoped>
    #travel_summary strong{
        font-weight: 900;
    }
    .ferry_type_selected {
        /* background-color: yellow; */
        opacity: 0.5;
    }
    button.ferry_type_active {
        /* background-color: blue; */
        opacity: 1;
        border: 3px solid #00b8d3!important;
    }
    .button_selection {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        /* align-items: center; */
    }
    .button_selection button{
        border: 3px solid #fff;
        margin: 5px;
    }
    .radio_div label{
        margin-left: 3px;
    }
    .radio_div {
        margin-top: 12px;
    }
    .radio_div .inline_input {
        padding: 4px;
        width: 60px;
        margin: 0 5px;
        display:inline-block;
    }
    .radio_div .size30 {
            width: 250px;
    }
    #ferry_companies input {
        width: 100%;
    }
    @media (max-width: 400px) {
        .booking-breakdown_block h2 {
            display:none;
        }
        .radio_div .size30 {
            width: 250px;
        }
        .button_selection button {
            /* background-color:#66B8D3; */
            /* display:none; */
        }
        span.indent {
            width: 20px;
            height: 20px;
            display:inline-block;
        }
        span.newline {
            display: block;
            height: 5px;
        }
    }    
</style>
